export default function ContactInfo({ variant = "light" }: { variant?: "light" | "dark" }) {
  const isDark = variant === "dark";

  return (
    <div className="lg:col-span-5 min-w-0">
      <div className={`rounded-xl md:rounded-2xl p-4 md:p-8 h-full border transition-all duration-500 ${
        isDark
          ? "bg-brand-blue border-brand-blue/30 text-white shadow-[0_4px_32px_rgba(20,58,102,0.2)]"
          : "bg-white border-brand-border shadow-[0_2px_24px_rgba(20,58,102,0.06)]"
      }`}>
        <h3 className={`text-lg font-bold mb-6 ${isDark ? "text-white" : "text-brand-blue"}`}>
          Contactez-nous
        </h3>
        <div className="space-y-6">
          <div className="flex items-start gap-3.5 group">
            <div className={`w-11 h-11 flex items-center justify-center shrink-0 rounded-xl transition-all duration-300 group-hover:scale-110 ${
              isDark ? "bg-white/10" : "bg-brand-cyan/10"
            }`}>
              <i className={`ri-phone-line text-lg ${isDark ? "text-brand-cyan" : "text-brand-cyan"}`}></i>
            </div>
            <div>
              <p className={`text-[10px] uppercase tracking-wider font-semibold mb-0.5 ${
                isDark ? "text-white/50" : "text-brand-text/50"
              }`}>
                Téléphone
              </p>
              <a
                href="tel:0374473240"
                className={`text-lg font-bold transition-colors duration-300 ${
                  isDark ? "text-white hover:text-brand-cyan" : "text-brand-blue hover:text-brand-cyan"
                }`}
              >
                03 74 47 32 40
              </a>
            </div>
          </div>

          <div className="flex items-start gap-3.5 group">
            <div className={`w-11 h-11 flex items-center justify-center shrink-0 rounded-xl transition-all duration-300 group-hover:scale-110 ${
              isDark ? "bg-white/10" : "bg-brand-cyan/10"
            }`}>
              <i className={`ri-map-pin-line text-lg ${isDark ? "text-brand-cyan" : "text-brand-cyan"}`}></i>
            </div>
            <div>
              <p className={`text-[10px] uppercase tracking-wider font-semibold mb-0.5 ${
                isDark ? "text-white/50" : "text-brand-text/50"
              }`}>
                Atelier Strasbourg
              </p>
              <p className={`text-sm leading-relaxed ${isDark ? "text-white/90" : "text-brand-text"}`}>
                82 Rue de Heidenberg<br />67200 Strasbourg
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3.5 group">
            <div className={`w-11 h-11 flex items-center justify-center shrink-0 rounded-xl transition-all duration-300 group-hover:scale-110 ${
              isDark ? "bg-white/10" : "bg-brand-cyan/10"
            }`}>
              <i className={`ri-time-line text-lg ${isDark ? "text-brand-cyan" : "text-brand-cyan"}`}></i>
            </div>
            <div>
              <p className={`text-[10px] uppercase tracking-wider font-semibold mb-0.5 ${
                isDark ? "text-white/50" : "text-brand-text/50"
              }`}>
                Horaires
              </p>
              <p className={`text-sm leading-relaxed ${isDark ? "text-white/90" : "text-brand-text"}`}>
                Lun – Ven : 8h – 19h<br />
                Sam : 9h – 17h<br />
                <span className={isDark ? "text-brand-cyan font-medium" : "text-brand-cyan font-medium"}>
                  Urgence : 24h/24
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}